import { createSlice } from '@reduxjs/toolkit';
import { IV1GetBusinessPossibleAppointmentsResponseSchema } from 'shared/repositories/announcements/entities/v1_get_business_possible_appointments/V1GetBusinessPossibleAppointmentsResponseSchema';

const initialState: IV1GetBusinessPossibleAppointmentsResponseSchema = {
  rentalBusiness: { items: [] },
  readyBusiness: { groups: [] },
};

export const businessAppointmentOptionsSlice = createSlice({
  name: 'businessAppointmentOptions',
  initialState,
  reducers: {},
});

export const { reducer: businessAppointmentOptionsReducer, name: businessAppointmentOptionsReducerName } =
  businessAppointmentOptionsSlice;
